import React, { useContext, useEffect, useState } from 'react';

import * as ui from '@digital/ui';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasByDiretoriaOptions } from '@app/api/area';
import { getAllDepartamentoProAreaIdOptions } from '@app/api/departamento';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import CurrencyInput from '@app/components/CurrencyInput';
import ModalSelectItemServico from '../QuestionarioContratacao/ModalSelectItemServico';
import { getAllCentroCustoOptions } from '@app/api/centrocusto';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { Visibility } from '@app/components';

interface IProps {
    
}

function AnaliseDemandaHistoricoModificacao({  }: IProps) {
    const { demandaData } = useContext(QuestionarioContextProvider);
    const [areas, setAreas] = useState<ui.OptionProps[]>();
    const [departamentos, setDepartamentos] = useState<ui.OptionProps[]>();
    const [tipoDespesa, setTipoDespesa] = useState('');
    
    if (!demandaData) {
        return (<></>);
    }

    useEffect(() => {
        if (demandaData.capex) {
            setTipoDespesa('capex');
        } else if (demandaData.opex) {
            setTipoDespesa('opex');
        } else if (demandaData.contaResultado) {
            setTipoDespesa('resultado');
        }

        getAllAreasByDiretoriaOptions(demandaData.diretoriaId)
            .then(data => {
                let areas = [...data, { text: 'N/A', value: 'na' }];
                setAreas(areas);
            });
        getAllDepartamentoProAreaIdOptions(demandaData.areaId)
            .then(data => {
                let departamentos = [...data, { text: 'N/A', value: 'na' }];
                setDepartamentos(departamentos);
            });

    }, [demandaData]);

    const dadosHistorico = demandaData.dadosHistorico || {};
    const tipoDespesaDadoHistorico = dadosHistorico.capex 
        ? 'capex' 
        : dadosHistorico.opex 
            ? 'opex' : 'resultado';

    return (
        <>
            <ui.Row>
                <ui.FormSelect
                    label="Diretoria"
                    name="diretoriaId"
                    id='mrn-select-diretoria-historico'
                    placeholder="Selecione uma opção"
                    getOptions={getAllDiretoriasOptions}
                    value={demandaData.diretoriaId}
                    span={4}
                    disabled
                />
                <ui.FormSelect
                    label="Área"
                    name="areaId"
                    id='mrn-select-area-historico'
                    placeholder="Selecione uma opção"
                    options={areas}
                    span={4}
                    value={demandaData.areaId}
                    disabled
                />

                <ui.FormSelect
                    label="Departamento"
                    name="departamentoId"
                    id='mrn-select-departamento-historico'
                    placeholder="Selecione uma opção"
                    options={departamentos}
                    value={demandaData.departamentoId}
                    span={4}
                    disabled
                />
            </ui.Row>

            <ui.Row>
                <ui.FormSelect
                    label="Tipo"
                    name="tipo"
                    id='mrn-select-tipo-historico'
                    span={4}
                    options={[
                        { value: 1, text: 'Nova Contratação' },
                        { value: 2, text: 'Aditivo' },
                        { value: 3, text: 'Acordo de Fornecimento' },
                        { value: 4, text: 'Faturamento Direto' },
                        { value: 5, text: 'Aditivo Faturamento Direto' },
                    ]}
                    disabled
                    value={demandaData.tipo}
                />
                
                <ui.FormSelect
                    id="mrn-select-tipoServico"
                    label="Tipo de Serviço"
                    name="tipoServicoId"
                    span={4}
                    getOptions={getTipoServicoOptions}
                    disabled
                />

                <ui.FormSelect
                    id='mrn-select-haveraMaoDeObraEmPTR-historico'
                    options={optionsSwitch}
                    label="Haverá parte ou totalidade da Mão-de-obra em PTR?"
                    name="haveraMaoDeObraEmPTR"
                    span={4}
                    disabled
                />
            </ui.Row>

            <ui.Row>
                <ui.FormTextArea
                    id="mrn-textarea-objetoASerContratado"
                    name="objeto"
                    label="Objeto a Ser Contratado"
                    rows={1}
                    disabled
                    value={dadosHistorico.objeto}
                />
            </ui.Row>

            <ui.Row>
                <CurrencyInput
                    name="valorTotalContratacao"
                    id='mrn-input-valorTotalContratacao-historico'
                    label="Valor Total Contratação"
                    disabled
                    span={demandaData.tipo === ETipoDemanda.NovaContratacao ? 4 : 2}
                    value={demandaData.tipo === ETipoDemanda.NovaContratacao 
                        ? dadosHistorico.valorContratacaoDemanda  
                        : dadosHistorico.novoValorFinal}
                />
                <Visibility
                    visible={demandaData.tipo === ETipoDemanda.Aditivo}
                >
                    <CurrencyInput
                        name="valorAditivo"
                        id='mrn-input-valorAditivo-historico'
                        label="Valor Aditivo"
                        disabled
                        span={2}
                        value={dadosHistorico.valorAditivo}
                    />
                </Visibility>
                <ui.FormInput
                    name="prazo"
                    label="Prazo (em meses)"
                    id='mrn-input-prazo-historico'
                    disabled
                    span={4}
                    value={dadosHistorico.expectativaDePrazo}
                />
                <ui.FormSelect
                    label="Tipo de Despesa"
                    span={4}
                    value={tipoDespesaDadoHistorico}
                    name="tipoDespesa"
                    id='mrn-select-tipoDespesa-historico'
                    options={[
                        { text: 'CAPEX', value: 'capex' },
                        { text: 'OPEX', value: 'opex' },
                        { text: 'Conta de Resultado', value: 'resultado' },
                    ]}
                    disabled
                />
            </ui.Row>

            {
                dadosHistorico.capex  &&
                <>
                    <ui.Row>
                        <ui.FormInput
                            id="mrn-input-codOrdemInvestimento"
                            name="codOrdemInvestimento"
                            label="Ordem Investimento"
                            value={dadosHistorico.capex ? dadosHistorico.codOrdemInvestimento : 'N/A'}
                            span={4}
                            disabled />
                        <ui.FormInput
                            id="mrn-input-ordemInvestimento"
                            name="ordemInvestimento"
                            label="Descrição Ordem Investimento"
                            value={dadosHistorico.capex ? dadosHistorico.ordemInvestimento : 'N/A'}
                            span={4}
                            disabled />
                        <ui.FormSelect
                            id="mrn-select-requisicaoAbertaPeloDepPlanejamentoControle"
                            options={optionsSwitch}
                            name="requisicaoAbertaPeloDepPlanejamentoControle"
                            label="A Requisição será aberta pelo Dep. de Planejamento e Controle?"
                            span={4}
                            value={!!dadosHistorico.requisicaoAbertaPeloDepPlanejamentoControle}
                            disabled
                        />
                    </ui.Row>

                    <ui.Row>
                        <ui.FormInput
                            name="pacote"
                            id='mrn-input-pacote-historico'
                            label="Pacote"
                            value={dadosHistorico.capex ? dadosHistorico.pacote : 'N/A'}
                            span={4} disabled />
                        <ui.FormInput
                            name="projeto"
                            id='mrn-input-projeto-historico'
                            label="Projeto"
                            value={dadosHistorico.capex ? dadosHistorico.projeto : 'N/A'}
                            span={4} disabled />
                        <ui.FormSelect
                            id='mrn-select-temPrevisaoOrcamentaria-historico'
                            options={optionsSwitch}
                            label="Está previsto na peça Orçamentária?"
                            name="temPrevisaoOrcamentaria"
                            span={4}
                            value={!!dadosHistorico.temPrevisaoOrcamentaria}
                            disabled={true}
                        />
                    </ui.Row>
                </>
            }

            {
                (dadosHistorico.contaResultado || dadosHistorico.opex) &&
                <>
                    <ui.Row>
                        <ModalSelectItemServico disabled={true} span={6} itemServicoSelecionado={dadosHistorico.codItemServico} />
                        <ui.FormSelect
                            label="Centro de Custo"
                            name="codCentroDeCusto"
                            id='mrn-select-centroDeCusto-historico'
                            span={2}
                            value={dadosHistorico.codCentroDeCusto}
                            getOptions={getAllCentroCustoOptions}
                            disabled
                        />
                        <ui.FormInput
                            label="Centro de Custo"
                            name="centroDeCusto"
                            id='mrn-input-centroDeCusto-historico'
                            value={dadosHistorico.centroDeCusto}
                            span={4}
                            disabled />
                    </ui.Row>

                    <ui.Row>
                        {
                            dadosHistorico.opex &&
                            <ui.FormInput
                                label="Ordem de Manutenção"
                                name="ordemManutencao"
                                id='mrn-input-ordemManutencao-historico'
                                value={dadosHistorico.ordemManutencao}
                                span={2}
                                disabled />
                        }
                        <ui.FormInput
                            label="Id orçamento"
                            name='orcamentoId'
                            id='mrn-input-orcamentoId-historico'
                            span={4} disabled />
                        <ui.Row>
                            <ui.FormSelect
                                id='mrn-select-temPrevisaoOrcamentaria-historico'
                                options={optionsSwitch}
                                label="Está previsto na peça Orçamentária?"
                                name="temPrevisaoOrcamentaria"
                                span={4}
                                value={!!dadosHistorico.temPrevisaoOrcamentaria}
                                disabled
                            />
                        </ui.Row>
                    </ui.Row>
                </>
            }

            <fieldset>
                <legend>Modificação</legend>
                <ui.Row>
                    <ui.FormTextArea
                        id="mrn-textarea-objetoASerContratado"
                        name="objeto"
                        label="Objeto a Ser Contratado"
                        rows={1}
                        disabled
                        value={demandaData.objeto}
                    />
                </ui.Row>

                <ui.Row>
                    <CurrencyInput
                        name="valorTotalContratacao"
                        id='mrn-input-valorTotalContratacao'
                        label="Valor Total Contratação"
                        disabled
                        span={demandaData.tipo === ETipoDemanda.NovaContratacao ? 4 : 2}
                        value={demandaData.tipo === ETipoDemanda.NovaContratacao 
                            ? demandaData.expectativaValorFinal  
                            : demandaData.novoValorFinal}
                    />
                    <Visibility
                        visible={demandaData.tipo === ETipoDemanda.Aditivo}
                    >
                        <CurrencyInput
                            name="valorAditivo"
                            id='mrn-input-valorAditivo'
                            label="Valor Aditivo"
                            disabled
                            span={2}
                            value={demandaData.valorAditivo}
                        />
                    </Visibility>
                    <ui.FormInput
                        name="prazo"
                        label="Prazo (em meses)"
                        id='mrn-input-prazo'
                        disabled
                        span={4}
                        value={demandaData.expectativaDePrazo}
                    />
                    <ui.FormSelect
                        label="Tipo de Despesa"
                        span={4}
                        value={tipoDespesa}
                        name="tipoDespesa"
                        id='mrn-select-tipoDespesa'
                        options={[
                            { text: 'CAPEX', value: 'capex' },
                            { text: 'OPEX', value: 'opex' },
                            { text: 'Conta de Resultado', value: 'resultado' },
                        ]}
                        disabled
                    />
                </ui.Row>
            </fieldset>
        </>
    );
}

export default AnaliseDemandaHistoricoModificacao;
